import React, { useContext } from 'react'
import styled from 'styled-components'
import { Flex, Hide, Text, Link, getPaletteColor } from 'pcln-design-system'
import { themeGet } from '@styled-system/theme-get'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import { Listing, RudderProductDesc } from './types'
import {
  fireEventForViewMoreDeals,
  renderXSellProducts
} from './inventoryHelper'

const ViewMoreDeals = styled(Link)`
  font-size: 12px;
  font-weight: bold;
  background-color: ${getPaletteColor('background.base')};
  border-radius: 16px;
`

const ScrollContainer = styled(Flex)`
  overflow: auto hidden;
  & > :last-child {
    margin-right: ${themeGet('space.1')}px;
  }
`
const InventoryWrapper = styled(Flex)`
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
`

export default function Inventory({
  xSellMessaging,
  xSellProduct,
  rudderChildProductCode,
  rudderParentProductCode,
  xSellUrl,
  listings,
  offerId,
  offerToken
}: {
  xSellMessaging: string
  xSellProduct: 'rental car' | 'flight' | 'hotel'
  rudderChildProductCode: RudderProductDesc
  rudderParentProductCode: RudderProductDesc
  xSellUrl: string
  listings: Listing[]
  offerId: string
  offerToken: string
}) {
  const {
    isMobile = false,
    webstats,
    customer
  } = useContext(BootstrapDataContext)
  const viewMoreDeals = ({ target }: { target?: string } = {}) => (
    <ViewMoreDeals
      data-cguid={webstats.clientGUID}
      data-email-address={customer.emailAddress}
      data-parent-offer-id={offerId}
      data-label={`View more ${xSellProduct} deals`}
      data-child-product={rudderChildProductCode}
      data-parent-product={rudderParentProductCode}
      data-has-inventory={listings.length}
      data-source="homepage"
      data-sub-type="cross sell"
      data-rudder-event
      data-view-more
      onClick={fireEventForViewMoreDeals}
      href={xSellUrl}
      target={target}
      color="primary.base"
      py={2}
      px={3}
    >
      View more {xSellProduct} deals
    </ViewMoreDeals>
  )
  const renderedProducts = renderXSellProducts(
    listings,
    isMobile ? 2 : 3,
    offerId,
    offerToken,
    rudderParentProductCode
  )
  return (
    <InventoryWrapper width={[1, 2 / 3, 8 / 11]}>
      <Flex flexDirection="column">
        <Flex
          justifyContent="space-between"
          alignItems="baseline"
          mb={2}
          mr={1}
        >
          <Text fontSize={[null, 1, null, null, 2]} fontWeight="bold">
            {xSellMessaging}
          </Text>
          <Hide xs sm md lg>
            {viewMoreDeals({ target: '_blank' })}
          </Hide>
        </Flex>
        <ScrollContainer data-testid="inventory-list">
          {renderedProducts}
        </ScrollContainer>
        <Hide xl xxl mt="10px">
          {viewMoreDeals()}
        </Hide>
      </Flex>
    </InventoryWrapper>
  )
}
